import { render, staticRenderFns } from "./GetGasAvailable.vue?vue&type=template&id=123d72fd&scoped=true"
import script from "./GetGasAvailable.vue?vue&type=script&lang=ts"
export * from "./GetGasAvailable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123d72fd",
  null
  
)

export default component.exports